// src/wizard/wizardPaths.ts
import type { WizardPathDefinition } from "./wizardTypes";

export const wizardPaths: WizardPathDefinition[] = [
  {
    id: "parentChild",
    landingTitle: "Register My Child",
    landingSubtitle: "Parent or guardian registration",
    topBarVariant: "Parent Info -> Children -> Emergency -> Review",
    steps: [
      { id: "parentInfo", title: "Parent / Guardian Info" },
      { id: "children", title: "Child Information" },
      { id: "emergency", title: "Emergency Contacts" },
      { id: "review", title: "Review and Submit" },
    ],
  },
  {
    id: "volunteerAndChild",
    landingTitle: "Volunteer & Register a Child",
    landingSubtitle: "Volunteer plus child registration",
    topBarVariant: "Your Info -> Children -> Emergency -> Review",
    steps: [
      { id: "volunteerInfo", title: "Your Information" },
      { id: "children", title: "Child Information" },
      { id: "emergency", title: "Emergency Contacts" },
      { id: "review", title: "Review and Submit" },
    ],
  },
  {
    id: "volunteerOnly",
    landingTitle: "Volunteer Only",
    landingSubtitle: "Volunteer registration only",
    topBarVariant: "Your Info -> Emergency -> Review",
    steps: [
      { id: "volunteerInfo", title: "Your Information" },
      { id: "emergency", title: "Emergency Contacts" },
      { id: "review", title: "Review and Submit" },
    ],
  },
];

export function getWizardPathById(pathId: string | null | undefined) {
  return wizardPaths.find((p) => p.id === pathId) ?? wizardPaths[0];
}
